// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict';

const siteRules = [
  { site: 'youtu.be', rule: '\\/(\\w+)$', url: 'https://www.youtube.com/embed/{code}'},
  { site: 'youtube.com/watch', rule: '\\?v=(\\w+)$', url:  'https://www.youtube.com/embed/{code}'}
]

function convertToEmbeddedURL(url) {
  let res = '';
  const successful = siteRules.some((x) => {
    if (url.includes(x.site)) {
      const re = RegExp(x.rule);
      const match = url.match(re);
      res = x.url.replace(/{code}/, match[1]);
      return true;
    }
  });
  if (successful) {
    return res;
  }
  return url;
}

export {
  convertToEmbeddedURL,
}
